export const endpoints = {
  pause: '/agentDuty/:agentDutyId/pause',
  resume: '/agentDuty/:agentDutyId/resume',
}
